import { API_BASE } from '../api/client';

const browserOrigin = typeof window === 'undefined' ? '' : window.location.origin;

export const STORE_BASE = (
  process.env.REACT_APP_STORE_URL ||
  (process.env.NODE_ENV === 'production' ? browserOrigin : 'http://localhost:3000')
).replace(/\/$/, '');

export const API_ORIGIN = (() => {
  try {
    return new URL(API_BASE || '/', browserOrigin).origin;
  } catch {
    return browserOrigin;
  }
})();

export const storeUrl = (path = '/') => `${STORE_BASE}/${String(path).replace(/^\/+/, '')}`;

export const resolveApiAsset = (source) => {
  const value = String(source || '').trim();
  if (!value || /^(https?:|data:|blob:|\/\/)/i.test(value)) return value;
  return `${API_ORIGIN}/${value.replace(/^\/+/, '')}`;
};

const assetPlaceholder = `data:image/svg+xml;utf8,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 240"><rect width="600" height="240" fill="#f3f4f6"/><text x="300" y="125" text-anchor="middle" font-family="Arial" font-size="24" fill="#9ca3af">Image unavailable</text></svg>'
)}`;

export const handleAdminAssetError = (event) => {
  if (event.currentTarget.getAttribute('src') !== assetPlaceholder) {
    event.currentTarget.src = assetPlaceholder;
  }
};
